import { Container, Stack } from "@mui/material";
import InfiniteScroll from "react-infinite-scroll-component";
import {
    InvalidDataReportDto,
    InvalidDataReportService,
} from "../../../api/psc";
import {
    EmptyListMessage,
    EndOfInfiniteListMessage,
    PageHeader,
    Spinner,
} from "../../../components/exports";
import useDynamicList from "../../../hooks/UseDynamicList";
import InvalidDataReportItem from "../components/InvalidDataReportItem";

// updated
export default function InvalidDataReport() {
    const manager = useDynamicList<InvalidDataReportDto>(async (offset) => {
        return InvalidDataReportService.listInvalidDataReports("1", offset);
    });

    return (
        <Container
            id="scrollableDiv-invalid-data-report"
            maxWidth="sm"
            sx={{ height: "100%", overflow: "auto" }}
        >
            <PageHeader title="لیست گزارشات خطا" />

            {manager.results.length === 0 && manager.requestInProgress && (
                <Spinner />
            )}

            {manager.empty && (
                <EmptyListMessage message="گزارش خطایی یافت نشد" />
            )}

            {manager.hasData && (
                <InfiniteScroll
                    scrollableTarget="scrollableDiv-invalid-data-report"
                    dataLength={manager.totalCount}
                    next={() => manager.loadMore()}
                    hasMore={manager.hasMore}
                    loader={<Spinner />}
                    endMessage={<EndOfInfiniteListMessage />}
                >
                    <Stack spacing={2}>
                        {manager.results.map((idr) => (
                            <InvalidDataReportItem
                                key={idr.id}
                                invalidDataReport={idr}
                            />
                        ))}
                    </Stack>
                </InfiniteScroll>
            )}
        </Container>
    );
}
